var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.753 511.753",
    style: {
      enableBackground: "new 0 0 511.753 511.753"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M105.807,70.621c7.106-6.709,30.72-16.419,53.389-23.817c-3.513,19.527,8.925,41.295,34.887,41.472 c6.268,0.044,9.454,0,17.655,0l-31.311,23.066c-14.23,10.134-17.152,30.517-5.614,43.635c0.177,0.194,0.353,0.397,0.538,0.6 c18.211,20.136,56.806,65.112,80.525,65.112s62.314-44.977,80.525-65.112c0.185-0.203,0.362-0.406,0.538-0.6 c11.538-13.118,8.616-33.501-5.614-43.635l-31.311-23.066c8.201,0,11.388,0.044,17.655,0c25.962-0.177,38.4-21.945,34.887-41.472 c22.669,7.398,46.283,17.108,53.389,23.817c19.862,18.759,67.31,295.177,88.276,397.241l-61.793,8.828 c0,0-39.724-220.142-45.798-238.345c-6.065-18.211-24.638-61.608-24.638-61.608c-8.898,25.194-16.49,61.334-17.611,96.918 l1.562,8.58h7.036c3.293,15.819,5.455,34.004,8.828,52.966h-5.932c10.125,47.678,23.587,112.967,23.587,158.897 c-35.31,17.655-88.276,17.655-123.586,17.655s-88.276,0-123.586-17.655c0-45.903,13.303-110.468,23.587-158.897h-5.932 c3.372-18.962,5.535-37.146,8.828-52.966h7.036l1.562-8.58c-1.121-35.584-8.713-71.724-17.611-96.918 c0,0-18.573,43.396-24.638,61.608c-6.073,18.202-45.798,238.345-45.798,238.345l-61.793-8.828 C38.497,365.798,85.945,89.379,105.807,70.621L105.807,70.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M229.394,335.203h-79.448c3.372-18.962,5.535-37.146,8.828-52.966h70.621V335.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M282.359,282.237h70.621c3.293,15.819,5.455,34.004,8.828,52.966h-79.448V282.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M194.083,8.828c-9.251,3.743-17.346,11.555-24.55,18.591c-0.088,0.088-0.177,0.177-0.265,0.265 c-20.895,20.18-10.487,60.354,24.814,60.593c6.268,0.044,9.454,0,17.655,0l-31.311,23.066 c-14.23,10.134-17.152,30.517-5.614,43.635c0.177,0.194,0.353,0.397,0.538,0.6c18.211,20.136,56.797,65.112,80.525,65.112v-44.138 C217.812,153.565,194.083,8.828,194.083,8.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M317.67,8.828c9.251,3.743,17.346,11.555,24.549,18.591c0.088,0.088,0.177,0.177,0.265,0.265 c20.895,20.18,10.487,60.354-24.814,60.593c-6.268,0.044-9.454,0-17.655,0l31.311,23.066c14.23,10.134,17.152,30.517,5.614,43.635 c-0.177,0.194-0.353,0.397-0.538,0.6c-18.211,20.136-56.797,65.112-80.525,65.112v-44.138 C293.941,153.565,317.67,8.828,317.67,8.828"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M255.876,0c-26.483,0-50.158,4.361-61.793,8.828l8.828,44.138h52.966h52.966l8.828-44.138 C306.035,4.361,282.359,0,255.876,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424B63"
    },
    d: "M255.876,52.966h-52.93c10.169,44.579,28.61,108.906,52.93,123.586 c24.32-14.68,42.761-79.007,52.93-123.586H255.876z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M133.614,467.479c41.631-1.783,72.863-43.723,55.631-88.135h-42.417 C141.091,408.758,135.91,439.804,133.614,467.479"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M364.919,379.341h-42.417c-17.231,44.412,14.001,86.351,55.631,88.135 C375.83,439.783,370.631,408.648,364.919,379.341"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M255.876,282.237c-4.882,0-8.828-3.946-8.828-8.828v-52.966c0-4.882,3.946-8.828,8.828-8.828 c4.882,0,8.828,3.946,8.828,8.828v52.966C264.704,278.291,260.758,282.237,255.876,282.237"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M264.704,511.733V344.027c0-4.873-3.946-8.828-8.828-8.828c-4.882,0-8.828,3.955-8.828,8.828 v167.706c2.984,0.009,6.047,0.018,8.828,0.018C258.657,511.751,261.72,511.742,264.704,511.733"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#424B63"
    },
    points: "282.359,335.203 300.014,335.203 326.497,308.72 300.014,282.237 282.359,282.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#424B63"
    },
    points: "229.394,344.032 282.359,344.032 282.359,273.412 229.394,273.412  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M255.876,326.375c-4.882,0-8.828-3.946-8.828-8.828v-17.655c0-4.882,3.946-8.828,8.828-8.828 c4.882,0,8.828,3.946,8.828,8.828v17.655C264.704,322.429,260.758,326.375,255.876,326.375"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoat);
export default __webpack_public_path__ + "static/media/coat.c91e5c0a15af91b1e158763c52a9ad9c.svg";
export { ForwardRef as ReactComponent };